import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const WeighbridgeIn = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [driver, setDriver] = useState("");
  const [driverCode, setDriverCode] = useState("");
  const [productsList, setProductsList] = useState([]);
  const [driversList, setDriversList] = useState([]);
  const [inwardNo, setInwardNo] = useState("");
  const [firstInwardNo, setFirstInwardNo] = useState("");
  const [lastInwardNo, setLastInwardNo] = useState("");
  // const [weight, setWeight] = useState("");
  const [emptyOrLoaded, setEmptyOrLoaded] = useState("");
  const [product, setProduct] = useState("");
  const [productCode, setProductCode] = useState("");
  const [wbNo, setWbNo] = useState("");
  const [wbName, setWbName] = useState("");
  const [wbData, setWbData] = useState([]);
  const [clerkData, setClerkData] = useState([]);
  const [clerk, setClerk] = useState("");
  const [clerkCode, setClerkCode] = useState("");
  const [isMultiple, setIsMultiple] = useState(false);
  const [weighBridgeNo, setWeighBridgeNo] = useState("");
  const [weighBridgeName, setWeighBridgeName] = useState("");
  const [tableData, setTableData] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [wbnoSearch, setWbnoSearch] = useState("");
  const [verificationNo, setVerificationNo] = useState("");
  const [noOfVehicles, setNoOfVehicles] = useState("");

  const [dataFromWorkshop, setDataFromWorkshop] = useState([]);
  const [isWorkshop, setIsWorkshop] = useState(false);
  const [showWorkshop, setShowWorkshop] = useState(false);
  const [vehicleNoWS, setVehicleNoWS] = useState("");
  const [driverWS, setDriverWS] = useState("");
  const [driverCodeWS, setDriverCodeWS] = useState("");
  const [gatePassNo, setGatePassNo] = useState("");
  const [wbNoWS, setWbNoWS] = useState("");
  const [wbNameWS, setWbNameWS] = useState("");
  const [clerkWS, setClerkWS] = useState("");
  const [clerkCodeWS, setClerkCodeWS] = useState("");
  const [isMultipleWS, setIsMultipleWS] = useState(false);
  const [weighBridgeNoWS, setWeighBridgeNoWS] = useState("");
  const [weighBridgeNameWS, setWeighBridgeNameWS] = useState("");
  const [tableDataWS, setTableDataWS] = useState([]);
  const [selectedRowIndexWS, setSelectedRowIndexWS] = useState(null);
  const [wbnoSearchWS, setWbnoSearchWS] = useState("");
  const [noOfVehiclesWS, setNoOfVehiclesWS] = useState("");
  const [verificationData, setVerificationData] = useState([]);
  const [proceedToStateIn, setProceedToStateIn] = useState("");
  const [proceedToStateValueIn, setProceedToStateValueIn] = useState("");

  const [histData, setHistData] = useState([]);
  const [showHist, setShowhist] = useState(false);
  const [searchHist, setSearchHist] = useState("");
  const [startDateHist, setStartDateHist] = useState("");
  const [endDateHist, setEndDateHist] = useState("");
  const [hist, setHist] = useState(false);

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString(),
  );

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer,
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !wbnoSearch) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["VEHICLE REG NO", "DRIVERNAME"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const wb = wbData?.find((value) => value?.WBNAME === wbnoSearch);
    const wbnoFilter = !wbnoSearch || item?.WEIGHBRIDGENO === wb?.WBNUMBER;

    return textMatch && wbnoFilter;
  });

  const filteredDataFromWorkshop = dataFromWorkshop.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !wbnoSearch) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["OT_VERIFICATION_VEHICLE", "WEIGHBRIGENUMBER"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });
    const wb = wbData?.find((value) => value?.WBNAME === wbnoSearch);
    const wbnoFilter = !wbnoSearch || item?.WEIGHBRIGENUMBER === wb?.WBNUMBER;
    return textMatch && wbnoFilter;
  });

  const filtHist = histData?.filter((item) => {
    const searchData = searchHist?.toLowerCase().split(" ").filter(Boolean);
    const sDate = new Date(item.OT_DISPATCH_DATE);
    const eDate = new Date(item.OT_DISPATCH_DATE);
    const startDate = startDateHist ? new Date(startDateHist) : null;
    const endDate = endDateHist ? new Date(endDateHist) : null;

    const textMatch = searchData.every((term) => {
      const otherMatch = [
        "OT_DISPATCH_NO",
        "OT_DISPATCH_LOADING_ORDER_NO",
        "OT_DISPATCH_VEHICLE_REG_NO",
        "OT_DISPATCH_NOTES",
        "OT_DISPATCH_INV_NO",
        "OT_DISPATCH_MILL_NO",
      ].some((key) => {
        const columnValue = String(item[key] || "").toLowerCase();
        return columnValue.includes(term);
      });

      return otherMatch;
    });

    const dateMatch =
      (!startDate || sDate >= startDate) && (!endDate || eDate <= endDate);

    return textMatch && dateMatch;
  });

  useEffect(() => {
    initialData();
    // initialDatas();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1229`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setInwardNo(response?.data[0]?.NEWDOCNO);
        setLastInwardNo(response?.data[0]?.NEWDOCNO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

    //   Items List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=625`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item.OM_ITEM_FINISHED_RAW_MATERIAL === "F",
        );
        setProductsList(filter);
        setProductsLists(filter);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Item Details:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
        setDriversLists(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1264`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWbData(response?.data);
        setWbDatas(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=611`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filteredData = response?.data?.filter(
          (item) => item?.DESIGNATION === "Weighbridge Clerk",
        );
        setClerkData(filteredData);
        setClerkDatas(filteredData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Clerk details:", error);
      });

    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1280`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((response) => {
    //     const filterData = response?.data?.filter(
    //       (item) => item.WEIGHBRIDGEINWARDSDONE === null,
    //     );
    //     setDataFromWorkshop(filterData);
    //     setisloading(false);
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching 1280:", error);
    //   });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1060`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filterData = response?.data?.filter(
          (item) =>
            item.OT_VERIFICATION_PROCEED_TO_STATE === "SENT FOR WEIGHBRIDGE",
        );
        setVerificationData(filterData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Clerk details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1228`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data
          ?.filter((item) => item?.SECONDWEIGHT === null)
          .sort((a, b) => a.WBTICKETNO - b.WBTICKETNO);
        setWeighinData(filter);
        setHistData(filter);
        setFirstInwardNo(filter?.[0]?.WBTICKETNO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Weigh in details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filterData = response?.data?.filter(
          (item) => item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE",
        );
        setVehiclesList(filterData);
        if (filterData?.length === 0) {
          setShowGateIn(true);
        }
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Clerk details:", error);
      });
  };

  async function getNewInwardNo() {
  await axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1229`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setInwardNo(response?.data[0]?.NEWDOCNO);
        setLastInwardNo(response?.data[0]?.NEWDOCNO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

}

  // Saving
  async function Save() {
    // await axios
    //   .get(`${BASEURL_GLOBAL}/globalSearchHandlerLimit?viewname=1228&sortBy=WBTICKETNO`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then(async(response) => {
    //     const sortedData = response?.data
    //       ?.filter((item) => item?.SECONDWEIGHT === null)
    //       .sort((a, b) => b.WBTICKETNO - a.WBTICKETNO);
    //     const isInwardAvailable = sortedData?.find(
    //       (item) =>
    //         item?.WBTICKETNO === Number(inwardNo),
    //     );
    //     if (
    //       isInwardAvailable &&
    //       sortedData[0]?.WBTICKETNO > lastInwardNo
    //     ) {
    //       await getNewInwardNo();
    //     }
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching Weigh in details:", error);
    //   });


    if (!driver) {
      alert("Kindly Supply the Driver");
      return;
    }

    // if (!weight) {
    //   alert("Kindly Provide the Weight");
    //   return;
    // }

    if (!wbName) {
      alert("Kindly Provide Weighbridge");
      return;
    }

    if (!clerk) {
      alert("Kindly Provide Weighbridge Clerk");
      return;
    }

    if (!proceedToStateValueIn) {
      alert("Kindly Provide Proceed To");
      return;
    }

    if (isMultiple && tableData?.length === 0) {
      alert("Kindly add the Weighbridge to Grid");
      return;
    }

    // if (!emptyOrLoaded) {
    //   alert("Kindly Supply Empty/Loaded");
    //   return;
    // }

    // if (emptyOrLoaded === "LOADED") {
    //   if (!product) {
    //     alert("Kindly Supply the Product");
    //     return;
    //   }
    // }

    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1230`,
        {
          FIRSTSECOND: "FIRST",
          WBTICKETNO: Number(inwardNo),
          WBNUMBER: Number(wbNo),
          TRUCKNO: vehicleNo ? vehicleNo : "",
          DRIVERCODE: driverCode ? driverCode : "",
          CLERKCODE: clerkCode,
          TRUCKEMPTYLOADEDONARRIVAL: "",
          // TRUCKEMPTYLOADEDONARRIVAL: emptyOrLoaded ? emptyOrLoaded : "",
          // PRODUCTONARRIVAL: productCode ? productCode : "",
          PRODUCTONARRIVAL: "",
          // FIRSTWEIGHT: Number(weight),
          FIRSTWEIGHT: 0,
          FIRSTWEIGHTDATETIME: moment(date).format("YYYY/MM/DD"),
          SECONDWEIGHT: 0,
          SECONDWEIGHTDATETIME: "",
          TRUCKEMPTYLOADEDONDEPARTURE: "",
          PRODUCTONDEPARTURE: "",
          CARGOWEIGHT: 0,
          MULTIPLEWEIGHBRIDGETOFOLLOW: isMultiple === true ? 1 : 0,
          PREVIOUSWBTICKETNO: 0,
          VERICATIONNO: verificationNo ? Number(verificationNo) : 0,
          WORKSHOPGATEPASSNO: 0,
          NEWEXISTING: hist === true ? "EXISTING" : "NEW",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        if (tableData?.length > 0) {
          alert(`Weighbridge Inward Updated successfully`);
          await SaveWeighbridge(response?.data?.message);
        }
        console.log(`Weighbridge Inward Updated successfully`);
        if (proceedToStateValueIn) {
          await SaveVehicleStateIn();
        } else {
          alert(`Weighbridge Inward Updated successfully`);
          setShowGateIn(false);
          window.location.reload();
        }
      } else {
        console.error(`Error while saving Weighbridge Inward`);
        alert(`Error while saving Weighbridge Inward`);
        setisloading(false);
      }
    } catch (error) {
      console.error(`Error while saving Weighbridge Inward `, error);
      alert(`Error while saving Weighbridge Inward `, error);
      setisloading(false);
    }
  }

  async function SaveVehicleStateIn() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE: proceedToStateValueIn,
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "SENT FOR WEIGHBRIDGE",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        // setisloading(false);
        // alert(`Vehicle State Updated successfully`);
        await SaveStateIn();
        console.log(`Vehicle State Updated successfully`);
      } else {
        console.error(`Error while saving Vehicle State`);
        alert(`Error while saving Vehicle State`);
        setisloading(false);
      }
    } catch (error) {
      console.error(`Error while saving Vehicle State `, error);
      alert(`Error while saving Vehicle State `, error);
      setisloading(false);
    }
  }

  async function SaveStateIn() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE: proceedToStateValueIn,
          DOC_NO: Number(inwardNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        alert(`Weighbridge Inward Updated successfully`);
        setisloading(false);
        window.location.reload();
        // alert(`State Updated successfully`);
        console.log(`State Updated successfully`);
      } else {
        console.error(`Error while saving State`);
        alert(`Error while saving State`);
        setisloading(false);
      }
    } catch (error) {
      console.error(`Error while saving State `, error);
      alert(`Error while saving State `, error);
      setisloading(false);
    }
  }

  const handleRowClick = (value, index) => {
    setDriver(value?.DRIVERNAME);
    const dri = driversList?.find(
      (item) => item?.DRIVERNAME === value?.DRIVERNAME,
    );
    setDriverCode(dri?.DRIVERCODE);
    setVehicleNo(value?.["VEHICLE REG NO"]);

    const wb = wbData?.find((item) => item?.WBNUMBER === value?.WEIGHBRIDGENO);
    setWbName(wb?.WBNAME);
    setWbNo(value?.WEIGHBRIDGENO);
    // setVerificationNo(value?.OT_VERIFICATION_NO);
    setShowGateIn(true);
  };

  const AddItemsToGrid = () => {
    if (!weighBridgeName) {
      alert("Please select WeighBridge");
      return;
    } else if (weighBridgeName === wbName) {
      alert(
        "Current weighbridge is same as the weighbridge you have selected ",
      );
      return;
    } else {
      const newItem = {
        OT_WEIGHBRIDGE_NO: weighBridgeNo,
        OT_WEIGHBRIDGE_NAME: weighBridgeName,
      };
      const existingRowIndex = tableData.findIndex(
        (charge) => charge.OT_WEIGHBRIDGE_NO === newItem.OT_WEIGHBRIDGE_NO,
      );

      if (existingRowIndex !== -1) {
        const updatedItems = [...tableData];
        updatedItems[existingRowIndex] = newItem;
        setTableData(updatedItems);
      } else {
        setTableData([...tableData, newItem]);
      }
      clearallinputs();
    }
  };

  const clearallinputs = () => {
    setSelectedRowIndex(null);
    setWeighBridgeNo("");
    setWeighBridgeName("");
    setNoOfVehicles("");
  };

  const RemoveItems = () => {
    const updatedValues = [...tableData];
    if (updatedValues.length === 0) {
      alert("There is no WeighBridges to be removed");
    } else {
      if (
        selectedRowIndex !== null &&
        selectedRowIndex >= 0 &&
        selectedRowIndex < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndex, 1);
        setSelectedRowIndex(null);
      } else {
        updatedValues.pop();
      }
      setTableData(updatedValues);
      clearallinputs();
    }
  };

  async function SaveWeighbridge(docNo) {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    for (let index = 0; index < tableData.length; index++) {
      const value = tableData[index];
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1275`,
          {
            OT_WEIGHBRIDGE_TICKET_NO: Number(docNo),
            OT_WEIGHBRIDGE_TO_FOLLOW_INDEX: Number(index + 1),
            OT_WEIGHBRIDGE_NO: Number(value.OT_WEIGHBRIDGE_NO),
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        setisloading(false);
        console.error(`Error while Saving Weighbridge`, error);
        alert(error.response.data.message);
      }
    }
    setisloading(false);
    if (successCount == tableData.length && successMessage) {
      alert("Weighbridge Details Saved Successfully");
    }
    if (errorMessage) {
      alert(errorMessage);
    }
  }

  // ******************** Data from workshop ***************************
  const handleRowClickWS = (value, index) => {
    setDriverCodeWS(value?.DRIVERCODE);
    const dri = driversList?.find(
      (item) => item?.DRIVERCODE === value?.DRIVERCODE,
    );
    setDriverWS(dri?.DRIVERNAME);
    setVehicleNoWS(value?.VEHICLE);
    const wb = wbData?.find(
      (item) => item?.WBNUMBER === value?.SENTOTOWEIGHBRIDGENO,
    );
    setWbNameWS(wb?.WBNAME);
    setWbNoWS(value?.SENTOTOWEIGHBRIDGENO);
    setGatePassNo(value?.GATEPASSNO);
    setShowWorkshop(true);
  };

  const AddItemsToGridWS = () => {
    if (!weighBridgeNameWS) {
      alert("Please select WeighBridge");
      return;
    } else if (weighBridgeNameWS === wbNameWS) {
      alert(
        "Current weighbridge is same as the weighbridge you have selected ",
      );
      return;
    } else {
      const newItem = {
        OT_WEIGHBRIDGE_NO: weighBridgeNoWS,
        OT_WEIGHBRIDGE_NAME: weighBridgeNameWS,
      };
      const existingRowIndex = tableDataWS.findIndex(
        (charge) => charge.OT_WEIGHBRIDGE_NO === newItem.OT_WEIGHBRIDGE_NO,
      );

      if (existingRowIndex !== -1) {
        const updatedItems = [...tableDataWS];
        updatedItems[existingRowIndex] = newItem;
        setTableDataWS(updatedItems);
      } else {
        setTableDataWS([...tableDataWS, newItem]);
      }
      clearallinputsWS();
    }
  };

  const clearallinputsWS = () => {
    setSelectedRowIndexWS(null);
    setWeighBridgeNoWS("");
    setWeighBridgeNameWS("");
    setNoOfVehiclesWS("");
  };

  const RemoveItemsWS = () => {
    const updatedValues = [...tableDataWS];
    if (updatedValues.length === 0) {
      alert("There is no WeighBridges to be removed");
    } else {
      if (
        selectedRowIndex !== null &&
        selectedRowIndex >= 0 &&
        selectedRowIndex < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndex, 1);
        setSelectedRowIndexWS(null);
      } else {
        updatedValues.pop();
      }
      setTableDataWS(updatedValues);
      clearallinputsWS();
    }
  };

  // Saving
  async function SaveWs() {
    if (!driverWS) {
      alert("Kindly Supply the Driver");
      return;
    }

    if (!wbNameWS) {
      alert("Kindly Provide Weighbridge");
      return;
    }

    if (!clerkWS) {
      alert("Kindly Provide Weighbridge Clerk");
      return;
    }

    if (isMultipleWS && tableDataWS?.length === 0) {
      alert("Kindly add the Weighbridge to Grid");
      return;
    }

    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1230`,
        {
          FIRSTSECOND: "FIRST",
          WBTICKETNO: Number(inwardNo),
          WBNUMBER: Number(wbNoWS),
          TRUCKNO: vehicleNoWS ? vehicleNoWS : "",
          DRIVERCODE: driverCodeWS ? driverCodeWS : "",
          CLERKCODE: clerkCodeWS,
          TRUCKEMPTYLOADEDONARRIVAL: "",
          PRODUCTONARRIVAL: "",
          FIRSTWEIGHT: 0,
          FIRSTWEIGHTDATETIME: moment(date).format("YYYY/MM/DD"),
          SECONDWEIGHT: 0,
          SECONDWEIGHTDATETIME: "",
          TRUCKEMPTYLOADEDONDEPARTURE: "",
          PRODUCTONDEPARTURE: "",
          CARGOWEIGHT: 0,
          MULTIPLEWEIGHBRIDGETOFOLLOW: isMultipleWS === true ? 1 : 0,
          PREVIOUSWBTICKETNO: 0,
          VERICATIONNO: 0,
          WORKSHOPGATEPASSNO: Number(gatePassNo),
          NEWEXISTING: hist === true ? "EXISTING" : "NEW",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Weighbridge Inward Updated successfully`);
        if (tableDataWS?.length > 0) {
          await SaveWeighbridgeWS(response?.data?.message);
        }
        console.log(`Weighbridge Inward Updated successfully`);
        setShowGateIn(false);
        window.location.reload();
      } else {
        setisloading(false);
        console.error(`Error while saving Weighbridge Inward`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Weighbridge Inward `, error);
    }
  }

  async function SaveWeighbridgeWS(docNo) {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    for (let index = 0; index < tableDataWS.length; index++) {
      const value = tableDataWS[index];
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1275`,
          {
            OT_WEIGHBRIDGE_TICKET_NO: Number(docNo),
            OT_WEIGHBRIDGE_TO_FOLLOW_INDEX: Number(index + 1),
            OT_WEIGHBRIDGE_NO: Number(value.OT_WEIGHBRIDGE_NO),
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        setisloading(false);
        console.error(`Error while Saving Weighbridge`, error);
        alert(error.response.data.message);
      }
    }
    setisloading(false);
    if (successCount == tableDataWS.length && successMessage) {
      alert("Weighbridge Details Saved Successfully");
    }
    if (errorMessage) {
      alert(errorMessage);
    }
  }

  const handleButtonClick = (action) => {
    let inwardNoToPass;
    switch (action) {
      case "first":
        inwardNoToPass = Number(firstInwardNo);
        break;
      case "decrement":
        inwardNoToPass = Number(inwardNo) - 1;
        if (inwardNoToPass < Number(firstInwardNo)) {
          alert("Cannot decrement further");
          return;
        }
        break;

      case "increment":
        inwardNoToPass = Number(inwardNo) + 1;
        if (inwardNoToPass >= Number(lastInwardNo)) {
          alert("No Further Inward number");
          return;
        }
        break;

      case "latest":
        inwardNoToPass = Number(lastInwardNo) - 1;
        break;
      default:
        break;
    }

    setInwardNo(inwardNoToPass);
    getNavData(inwardNoToPass);
  };

  async function getNavData(inward) {
    const item = histData?.find((value) => value?.WBTICKETNO === inward);

    if (item) {
      setInwardNo(item?.["WBTICKETNO"]);
      setWbName(item?.["WEIGHBRIDGENAME"] || "");
      setWbNo(item?.["WEIGHBRIDGENUMBER"] || "");
      setVehicleNo(item?.["TRUCKNO"] || "");

      setClerkCode(item?.["WEIGHBRIDGECLERK"] || "");
      const clerk = clerkData?.find(
        (value) => value?.["EMPLOYEE CODE"] === item?.WEIGHBRIDGECLERK,
      );
      setClerk(clerk?.["EMPLOYEE NAME"]);
      setDate(item?.["FIRSTWEIGHTDATETIME"] || "");
      setEmptyOrLoaded(item?.["TRUCKEMPTYLOADEDONARRIVAL"] || "");
      setDriverCode(item?.["DRIVERCODE"] || "");
      const driver = driversList?.find(
        (value) => value?.DRIVERCODE === item?.DRIVERCODE,
      );
      setDriver(driver?.DRIVERNAME);
      setHist(true)
    } else {
      // Auto-decrement if record not found
      const allVouchers = [...(histData || [])]
        .map((item) => Number(item?.WBTICKETNO))
        .sort((a, b) => a - b);

      const currentInward = Number(inward);

      // Determine whether this was likely an increment or decrement action
      const lastInward = Number(inwardNo);

      const isIncrement = currentInward > lastInward;

      if (isIncrement) {
        // Find next existing record greater than the current one
        const nextExisting = allVouchers.find((num) => num > currentInward);
        if (nextExisting !== undefined) {
          console.warn(`inward No ${inward} not found, trying ${nextExisting}`);
          await getNavData(nextExisting);
          return;
        } else {
          alert(`No further inward No found after ${inward}`);
        }
      } else {
        const previousExisting = [...allVouchers]
          .reverse()
          .find((num) => num < Number(inward));

        if (previousExisting !== undefined) {
          console.warn(
            `inward No ${inward} not found, trying ${previousExisting}`,
          );
          await getNavData(previousExisting);
          return;
        } else {
          alert(`No existing inward No found before ${inward}`);
        }
      }
    }
  }

  // ********** EXPORT TO PDF AND EXCEL **************
  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Weighbridge In");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [10, 25, 25, 25, 25, 15];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "Inward No",
      "WeighBridge",
      "Vehicle",
      "Driver",
      "Clerk",
      "Date",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Weighbridge_In.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text("Weighbridge In - Report", 10, 10);

    const columns = [
      "Inward No",
      "WeighBridge",
      "Vehicle",
      "Driver",
      "Clerk",
      "Date",
    ];

    const data = filtHist.map((stock) => {
      const driver = driversList?.find(
        (value) => value?.DRIVERCODE === stock?.DRIVERCODE,
      );

      const clerk = clerkData?.find(
        (value) => value?.["EMPLOYEE CODE"] === stock?.WEIGHBRIDGECLERK,
      );

      return [
        stock.WBTICKETNO,
        stock.WEIGHBRIDGENAME,
        stock.TRUCKNO,
        driver?.["DRIVERNAME"],
        clerk?.["EMPLOYEE NAME"],
        stock.FIRSTWEIGHTDATETIME
          ? moment(stock.FIRSTWEIGHTDATETIME).format("DD/MM/YYYY")
          : "",
      ];
    });

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("Weighbridge_In.pdf");
  };

  // ************************** GATE OUT *****************
  //  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIns, setShowGateIns] = useState(false);
  const [dates, setDates] = useState(new Date().toISOString());
  const [vehicleNos, setVehicleNos] = useState("");
  const [drivers, setDrivers] = useState("");
  const [driverCodes, setDriverCodes] = useState("");
  const [productsLists, setProductsLists] = useState([]);
  const [driversLists, setDriversLists] = useState([]);
  const [inwardNos, setInwardNos] = useState("");
  const [weight, setWeight] = useState("");
  // const [emptyOrLoaded, setEmptyOrLoaded] = useState("");
  // const [product, setProduct] = useState("");
  // const [productCode, setProductCode] = useState("");
  const [weighinData, setWeighinData] = useState([]);
  const [weightOut, setWeightOut] = useState("");
  const [emptyOrLoadedOut, setEmptyOrLoadedOut] = useState("");
  const [dateout, setDateOut] = useState(new Date().toISOString());
  const [timeOut, setTimeOut] = useState(new Date().toLocaleTimeString());
  const [productOut, setProductOut] = useState("");
  const [productCodeOut, setProductCodeOut] = useState("");
  const [proceedToState, setProceedToState] = useState("");
  const [proceedToStateValue, setProceedToStateValue] = useState("");
  const [wbNos, setWbNos] = useState("");
  const [wbNames, setWbNames] = useState("");
  const [wbDatas, setWbDatas] = useState([]);
  const [clerkDatas, setClerkDatas] = useState([]);
  const [clerks, setClerks] = useState("");
  const [clerkCodes, setClerkCodes] = useState("");
  const [wbnoSearchs, setWbnoSearchs] = useState("");
  const [searchs, setSearchs] = useState("");

  // const [currentTime, setCurrentTime] = useState(
  //   new Date().toLocaleTimeString()
  // );

  // const VehicleDepartment = useSelector(
  //   (state) => state?.VehicleDepartmentReducer
  // );

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeOut(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredDatas = weighinData.filter((item) => {
    const searchData = searchs.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !wbnoSearchs) {
      return true;
    }

    const driver = driversLists?.find(
      (value) => value?.DRIVERCODE === item?.DRIVERCODE,
    );

    const textMatch = searchData.every((term) => {
      const driverMatch =
        driver?.DRIVERNAME?.toLowerCase()?.includes(term) ?? false;

      const otherMatch = ["WBTICKETNO", "TRUCKNO"].some((key) => {
        const columnValue = String(item[key] || "").toLowerCase();
        return columnValue.includes(term);
      });

      return driverMatch || otherMatch;
    });

    const wbnoFilter = !wbnoSearchs || item?.WEIGHBRIDGENAME === wbnoSearchs;

    return textMatch && wbnoFilter;
  });

  const initialDatas = () => {
    //   Items List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=625`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item.OM_ITEM_FINISHED_RAW_MATERIAL === "F",
        );
        setProductsLists(filter);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Item Details:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversLists(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1264`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWbDatas(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=611`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filteredData = response?.data?.filter(
          (item) => item?.DESIGNATION === "Weighbridge Clerk",
        );
        setClerkDatas(filteredData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Clerk details:", error);
      });

    //   Saved weigh in data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1228`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item?.SECONDWEIGHT === null,
        );
        setWeighinData(filter);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Weigh in details:", error);
      });

    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((response) => {
    //     if (VehicleDepartment !== "") {
    //       const filterData = response?.data?.filter(
    //         (item) =>
    //           item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE" &&
    //           item?.DEPARTMENT === VehicleDepartment
    //       );
    //       setVehiclesList(filterData);
    //     } else {
    //       const filterData = response?.data?.filter(
    //         (item) => item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE"
    //       );
    //       setVehiclesList(filterData);
    //     }
    //     setisloading(false);
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching Charges details:", error);
    //   });
  };

  // Saving
  async function SaveOut() {
    // if (!weightOut) {
    //   alert("Kindly Provide the Weight at departure");
    //   return;
    // }

    if (!wbNames) {
      alert("Kindly Provide Weighbridge");
      return;
    }

    if (!clerks) {
      alert("Kindly Provide Weighbridge Clerk");
      return;
    }

    // if (emptyOrLoadedOut === "LOADED") {
    //   if (!productOut) {
    //     alert("Kindly Supply the Product at departure");
    //     return;
    //   }
    // }

    // if (emptyOrLoadedOut === "EMPTY") {
    //   if (Number(weight) <= Number(weightOut)) {
    //     alert(
    //       "Weight at departure can not be greater than Weight at Arrival as it is EMPTY"
    //     );
    //     return;
    //   }
    // }

    if (!proceedToState) {
      alert("Kindly Supply the State");
      return;
    }

    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1230`,
        {
          FIRSTSECOND: "SECOND",
          WBTICKETNO: Number(inwardNos),
          WBNUMBER: Number(wbNos),
          TRUCKNO: vehicleNos ? vehicleNos : "",
          DRIVERCODE: driverCodes ? driverCodes : "",
          CLERKCODE: clerkCodes,
          // TRUCKEMPTYLOADEDONARRIVAL: emptyOrLoaded ? emptyOrLoaded : "",
          TRUCKEMPTYLOADEDONARRIVAL: "",
          // PRODUCTONARRIVAL: productCode ? productCode : "",
          PRODUCTONARRIVAL: "",
          // FIRSTWEIGHT: Number(weight),
          FIRSTWEIGHT: 0,
          FIRSTWEIGHTDATETIME: moment(dates).format("YYYY/MM/DD"),
          // SECONDWEIGHT: Number(weightOut),
          SECONDWEIGHT: 0,
          SECONDWEIGHTDATETIME: moment(dateout).format("YYYY/MM/DD"),
          // TRUCKEMPTYLOADEDONDEPARTURE: emptyOrLoadedOut,
          TRUCKEMPTYLOADEDONDEPARTURE: "",
          // PRODUCTONDEPARTURE: productCodeOut,
          PRODUCTONDEPARTURE: "",
          CARGOWEIGHT: 0,
          MULTIPLEWEIGHBRIDGETOFOLLOW: 0,
          PREVIOUSWBTICKETNO: 0,
          VERICATIONNO: 0,
          WORKSHOPGATEPASSNO: 0,
          NEWEXISTING: "EXISTING",
          // CARGOWEIGHT:
          //   Number(weight) > Number(weightOut)
          //     ? Number(weight) - Number(weightOut)
          //     : Number(weightOut) - Number(weight),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Weighbridge Outward Updated successfully`);
        console.log(`Weighbridge Outward Updated successfully`);
        await SaveVehicleState();
        await SaveState(response?.data?.message);
        setShowGateIns(false);
        window.location.reload();
      } else {
        setisloading(false);
        console.error(`Error while saving Weighbridge Outward`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Weighbridge Outward `, error);
    }
  }

  async function SaveVehicleState() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNos,
          OT_VEHICLE_STATE: proceedToStateValue,
          OT_VEHICLE_STATE_DATE: moment(dateout).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: timeOut,
          OT_VEHICLE_PREVIOUS_STATE: "SENT FOR WEIGHBRIDGE",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Vehicle State Updated successfully`);
        console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
    }
  }

  async function SaveState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE: proceedToStateValue,
          DOC_NO: Number(docNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`State Updated successfully`);
        console.log(`State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving State `, error);
    }
  }

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Weighbridge In
        </h1>
        <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        />
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
        <p className="text-red-600 lg:ml-2">Weighbridge :</p>
        <Select
          className="lg:w-64 lg:ml-2"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
          value={
            wbnoSearch
              ? { value: wbnoSearch, label: wbnoSearch }
              : { value: "", label: "Select" }
          }
          onChange={(e) => {
            setWbnoSearch(e.value);
          }}
          options={[
            { value: "", label: "Select" },
            ...wbData?.map((item) => ({
              value: item?.WBNAME,
              label: item?.WBNAME,
            })),
          ]}
        ></Select>
      </div>

      <div className="visible lg:h-[250px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                WEIGHBRIDGE
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => {
              const wb = wbData?.find(
                (item) => item?.WBNUMBER === value?.WEIGHBRIDGENO,
              );

              return (
                <tr
                  key={index}
                  className="hover:bg-gray-100 cursor-pointer text-[13px]"
                  onClick={() => handleRowClick(value, index)}
                >
                  <td className="py-2 px-4 text-right border border-gray-300">
                    {index + 1}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value?.["VEHICLE REG NO"] || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value?.DRIVERNAME || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {wb?.WBNAME || "N/A"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[450px] h-[80%] lg:w-[950px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="text-3xl font-bold flex lg:justify-center justify-start">
            WEIGHBRIDGE IN
          </h1>

                    <div className="flex lg:ml-2 gap-1 lg:mr-2">
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("first");
              }}
            >
              {"<<"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("decrement");
              }}
            >
              {"<"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("increment");
              }}
            >
              {">"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("latest");
              }}
            >
              {">>"}
            </button>
          </div>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Inward No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-8 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={inwardNo}
              readOnly
            ></input>

            <button
              className="border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                setShowhist(true);
              }}
            >
              ...
            </button>

            {showHist && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[400px] h-[80%] lg:w-[870px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={searchHist}
                    onChange={(e) => {
                      setSearchHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">Start Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={startDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setStartDateHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">End Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={endDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setEndDateHist(e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setShowhist(false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
                  <div className="flex justify-end gap-2">
                    <div className="cursor-pointer">
                      <RiFileExcel2Line onClick={ExcelStockData} size={25} />
                    </div>
                    <div className="cursor-pointer">
                      <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
                    </div>
                  </div>

                  <table className="w-full border border-gray-300 text-sm table_1">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px] table-header">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Inward No
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          WeighBridge
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Vehicle
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Driver
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Clerk
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Date
                        </td>
                        {/* <td className="py-2 px-4 text-left border border-gray-300">
                          Empty/Loaded
                        </td> */}
                      </tr>
                    </thead>
                    <tbody>
                      {filtHist?.map((item, index) => {
                        const driver = driversList?.find(
                          (value) => value?.DRIVERCODE === item?.DRIVERCODE,
                        );
                        const clerk = clerkData?.find(
                          (value) =>
                            value?.["EMPLOYEE CODE"] === item?.WEIGHBRIDGECLERK,
                        );

                        return (
                          <tr
                            className="hover:bg-gray-100 cursor-pointer text-[13px]"
                            onClick={() => {
                              setInwardNo(item?.["WBTICKETNO"]);
                              setWbName(item?.["WEIGHBRIDGENAME"] || "");
                              setWbNo(item?.["WEIGHBRIDGENUMBER"] || "");
                              setVehicleNo(item?.["TRUCKNO"] || "");

                              setClerkCode(item?.["WEIGHBRIDGECLERK"] || "");
                              const clerk = clerkData?.find(
                                (value) =>
                                  value?.["EMPLOYEE CODE"] ===
                                  item?.WEIGHBRIDGECLERK,
                              );
                              setClerk(clerk?.["EMPLOYEE NAME"]);
                              setDate(item?.["FIRSTWEIGHTDATETIME"] || "");
                              setEmptyOrLoaded(
                                item?.["TRUCKEMPTYLOADEDONARRIVAL"] || "",
                              );
                              setDriverCode(item?.["DRIVERCODE"] || "");
                              const driver = driversList?.find(
                                (value) =>
                                  value?.DRIVERCODE === item?.DRIVERCODE,
                              );
                              setDriver(driver?.DRIVERNAME);
                              setHist(true)
                              setShowhist(false);
                            }}
                            key={index}
                          >
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item?.["WBTICKETNO"]
                                ? item?.["WBTICKETNO"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item?.["WEIGHBRIDGENAME"]
                                ? item?.["WEIGHBRIDGENAME"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["TRUCKNO"] ? item?.["TRUCKNO"] : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {driver?.["DRIVERNAME"]
                                ? driver?.["DRIVERNAME"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {clerk?.["EMPLOYEE NAME"]
                                ? clerk?.["EMPLOYEE NAME"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["FIRSTWEIGHTDATETIME"]
                                ? moment(item?.["FIRSTWEIGHTDATETIME"]).format(
                                    "DD/MM/YYYY",
                                  )
                                : "NA"}
                            </td>
                            {/* <td className="py-2 px-4 border border-gray-300">
                              {item?.["TRUCKEMPTYLOADEDONARRIVAL"]
                                ? item?.["TRUCKEMPTYLOADEDONARRIVAL"]
                                : "NA"}
                            </td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <p className="text-red-600 lg:ml-20">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-20">Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
          </div>

          {/* Row 2 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-12 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-5">Driver :</p>
            <Select
              className="lg:w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driver
                  ? { value: driver, label: driver }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriver(e.label);
                setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERCODE,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>
            <p className="text-red-600 lg:ml-2">Weighbridge :</p>
            <input
              className="w-56 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={wbName}
              readOnly
            ></input>

            {/* <p className="text-red-600 lg:ml-2">Weight :</p>
            <input
              className="w-24 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="number"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
            ></input> */}
          </div>

          {/* Row 3 */}
          {/* <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Product :</p>
            <Select
              className="lg:w-56 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                product
                  ? { value: product, label: product }
                  : { value: "", label: "Select Product" }
              }
              onChange={(e) => {
                setProduct(e.label);
                setProductCode(e.value);
              }}
              options={[
                { value: "", label: "Select Product" },
                ...productsList?.map((item) => ({
                  value: item.ITEMCODE,
                  label: item.ITEMDESCRIPTION,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-2 mr-1">Empty Or Loaded :</p>
            <Select
              className="lg:w-56 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                emptyOrLoaded
                  ? { value: emptyOrLoaded, label: emptyOrLoaded }
                  : { value: "", label: "Select Empty/Loaded" }
              }
              onChange={(e) => {
                setEmptyOrLoaded(e.value);
              }}
              options={[
                { value: "", label: "Select Empty/Label" },
                { value: "EMPTY", label: "EMPTY" },
                { value: "LOADED", label: "LOADED" },
              ]}
            ></Select>
          </div> */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Weighbridge Clerk :</p>
            <Select
              className="lg:w-56 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                clerk
                  ? { value: clerk, label: clerk }
                  : { value: "", label: "Select Weighbridge Clerk" }
              }
              onChange={(e) => {
                setClerk(e.label);
                setClerkCode(e.value);
              }}
              options={[
                { value: "", label: "Select Weighbridge Clerk" },
                ...clerkData?.map((item) => ({
                  value: item["EMPLOYEE CODE"],
                  label: item["EMPLOYEE NAME"],
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-12">Proceed To :</p>
            <Select
              className="lg:w-80 lg:ml-2"
              menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
              }}
              value={
                proceedToStateIn
                  ? { value: proceedToStateIn, label: proceedToStateIn }
                  : { value: "", label: "Select State" }
              }
              onChange={(e) => {
                setProceedToStateIn(e.label);
                setProceedToStateValueIn(e.value);
              }}
              options={[
                { value: "", label: "Select State" },
                { value: "SENT TO WORKSHOP", label: "PROCEED TO WORKSHOP" },
                { value: "SENT TO LOAD", label: "PROCEED TO LOAD" },
              ]}
            ></Select>
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Multiple Weighbridges ?</p>
            <input
              className="w-5 h-5"
              type="checkbox"
              checked={isMultiple}
              onChange={() => setIsMultiple(!isMultiple)}
            ></input>
            {isMultiple && (
              <>
                <Select
                  className="lg:w-56 w-64 lg:ml-2"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  value={
                    weighBridgeName
                      ? { value: weighBridgeName, label: weighBridgeName }
                      : { value: "", label: "Select Weighbridge" }
                  }
                  onChange={(e) => {
                    setWeighBridgeName(e.label);
                    setWeighBridgeNo(e.value);
                    const weigh = vehiclesList?.filter(
                      (item) => item?.WEIGHBRIGENUMBER === e.value,
                    );
                    setNoOfVehicles(weigh?.length);
                  }}
                  options={[
                    { value: "", label: "Select Weighbridge" },
                    ...wbData?.map((item) => ({
                      value: item.WBNUMBER,
                      label: item.WBNAME,
                    })),
                  ]}
                ></Select>
                <p className="text-red-600 lg:ml-2 mr-1">No Of Vehicles :</p>
                <input
                  className="w-16 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={noOfVehicles}
                  readOnly
                ></input>
                <button
                  className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => AddItemsToGrid()}
                >
                  Add
                </button>
                <button
                  className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => RemoveItems()}
                >
                  Remove
                </button>
              </>
            )}
          </div>

          {isMultiple && tableData?.length > 0 && (
            <div className="visible lg:h-[150px] p-1 z-0 lg:overflow-auto mt-2">
              <table className="w-full border border-gray-300 text-sm">
                <thead className="sticky top-0">
                  <tr className="bg-[#2b3f5c] text-white text-[12px]">
                    <td className="py-2 px-4 text-right border border-gray-300">
                      SNO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      WEIGHBRIDGE NO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      WEIGHBRIDGE NAME
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {tableData?.map((value, index) => (
                    <tr
                      key={value.OT_WEIGHBRIDGE_NO}
                      className="hover:bg-gray-100 cursor-pointer text-[13px]"
                      onClick={() => {
                        setWeighBridgeNo(value?.OT_WEIGHBRIDGE_NO);
                        setWeighBridgeName(value?.OT_WEIGHBRIDGE_NAME);
                        const weigh = vehiclesList?.filter(
                          (item) =>
                            item?.WEIGHBRIGENUMBER === value?.OT_WEIGHBRIDGE_NO,
                        );
                        setNoOfVehicles(weigh?.length);
                      }}
                    >
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {index + 1}
                      </td>
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {value.OT_WEIGHBRIDGE_NO || "N/A"}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.OT_WEIGHBRIDGE_NAME || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="flex justify-center mt-5">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                await Save();
              }}
            >
              WEIGH IN
            </button>
          </div>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}

      {/* DATA FROM WORKSHOP  */}
      {/* <h1 className="mt-4 text-lg underline text-red-500">
        PENDING TO WEIGHBRIDGED INWARDS FROM WORKSHOP
      </h1> */}
      {/* <div className="visible lg:h-[250px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                WEIGHBRIDGE
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredDataFromWorkshop.map((value, index) => {
              const dri = driversList?.find(
                (item) => item?.DRIVERCODE === value?.DRIVERCODE,
              );

              const wb = wbData?.find(
                (item) => item?.WBNUMBER === value?.SENTOTOWEIGHBRIDGENO,
              );

              return (
                <tr
                  key={index}
                  className="hover:bg-gray-100 cursor-pointer text-[13px]"
                  onClick={() => handleRowClickWS(value, index)}
                >
                  <td className="py-2 px-4 text-right border border-gray-300">
                    {index + 1}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value?.VEHICLE || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {dri?.DRIVERNAME || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {wb?.WBNAME || "N/A"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div> */}

      {/* PopUp */}
      {showWorkshop && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[450px] h-[80%] lg:w-[820px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="text-3xl font-bold flex lg:justify-center justify-start">
            WEIGHBRIDGE IN
          </h1>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Inward No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-8 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={inwardNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-20">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-20">Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
          </div>

          {/* Row 2 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-12 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNoWS}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-5">Driver :</p>
            <Select
              className="lg:w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driverWS
                  ? { value: driverWS, label: driverWS }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriverWS(e.label);
                setDriverCodeWS(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERCODE,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>
          </div>
          {/* row3 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Weighbridge :</p>

            <input
              className="w-56 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={wbNameWS}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2 mr-1">Weighbridge Clerk :</p>

            <Select
              className="lg:w-56 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                clerkWS
                  ? { value: clerkWS, label: clerkWS }
                  : { value: "", label: "Select Weighbridge Clerk" }
              }
              onChange={(e) => {
                setClerkWS(e.label);
                setClerkCodeWS(e.value);
              }}
              options={[
                { value: "", label: "Select Weighbridge Clerk" },
                ...clerkData?.map((item) => ({
                  value: item["EMPLOYEE CODE"],
                  label: item["EMPLOYEE NAME"],
                })),
              ]}
            ></Select>
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Multiple Weighbridges ?</p>
            <input
              className="w-5 h-5"
              type="checkbox"
              checked={isMultipleWS}
              onChange={() => setIsMultipleWS(!isMultipleWS)}
            ></input>
            {isMultipleWS && (
              <>
                <Select
                  className="lg:w-56 w-64 lg:ml-2"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  value={
                    weighBridgeNameWS
                      ? { value: weighBridgeNameWS, label: weighBridgeNameWS }
                      : { value: "", label: "Select Weighbridge" }
                  }
                  onChange={(e) => {
                    setWeighBridgeNameWS(e.label);
                    setWeighBridgeNoWS(e.value);
                    const weigh = vehiclesList?.filter(
                      (item) => item?.WEIGHBRIGENUMBER === e.value,
                    );
                    setNoOfVehiclesWS(weigh?.length);
                  }}
                  options={[
                    { value: "", label: "Select Weighbridge" },
                    ...wbData?.map((item) => ({
                      value: item.WBNUMBER,
                      label: item.WBNAME,
                    })),
                  ]}
                ></Select>
                <p className="text-red-600 lg:ml-2 mr-1">No Of Vehicles :</p>
                <input
                  className="w-16 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={noOfVehiclesWS}
                  readOnly
                ></input>
                <button
                  className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => AddItemsToGridWS()}
                >
                  Add
                </button>
                <button
                  className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => RemoveItemsWS()}
                >
                  Remove
                </button>
              </>
            )}
          </div>

          {isMultipleWS && tableDataWS?.length > 0 && (
            <div className="visible lg:h-[150px] p-1 z-0 lg:overflow-auto mt-2">
              <table className="w-full border border-gray-300 text-sm">
                <thead className="sticky top-0">
                  <tr className="bg-[#2b3f5c] text-white text-[12px]">
                    <td className="py-2 px-4 text-right border border-gray-300">
                      SNO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      WEIGHBRIDGE NO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      WEIGHBRIDGE NAME
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {tableDataWS?.map((value, index) => (
                    <tr
                      key={value.OT_WEIGHBRIDGE_NO}
                      className="hover:bg-gray-100 cursor-pointer text-[13px]"
                      onClick={() => {
                        setWeighBridgeNoWS(value?.OT_WEIGHBRIDGE_NO);
                        setWeighBridgeNameWS(value?.OT_WEIGHBRIDGE_NAME);
                        const weigh = vehiclesList?.filter(
                          (item) =>
                            item?.WEIGHBRIGENUMBER === value?.OT_WEIGHBRIDGE_NO,
                        );
                        setNoOfVehiclesWS(weigh?.length);
                      }}
                    >
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {index + 1}
                      </td>
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {value.OT_WEIGHBRIDGE_NO || "N/A"}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.OT_WEIGHBRIDGE_NAME || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="flex justify-center mt-5">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                await SaveWs();
              }}
            >
              WEIGH IN
            </button>
          </div>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowWorkshop(false)}
          >
            Close
          </button>
        </div>
      )}

      {/* WEIGH OUT */}
      <h1 className="mt-4 text-lg underline text-red-500">PENDING WEIGH OUT</h1>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={searchs}
            onChange={(e) => {
              setSearchs(e.target.value);
            }}
          ></input>
        </div>

        <p className="text-red-600 lg:ml-2">Weighbridge :</p>
        <Select
          className="lg:w-64 lg:ml-2"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
          value={
            wbnoSearchs
              ? { value: wbnoSearchs, label: wbnoSearchs }
              : { value: "", label: "Select" }
          }
          onChange={(e) => {
            setWbnoSearchs(e.value);
          }}
          options={[
            { value: "", label: "Select" },
            ...weighinData?.map((item) => ({
              value: item?.WEIGHBRIDGENAME,
              label: item?.WEIGHBRIDGENAME,
            })),
          ]}
        ></Select>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                WEIGHBRIDGE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              {/* <td className="py-2 px-4 text-left border border-gray-300">
                      EMPTY/LOADED
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      PRODUCT ON ARRIVAL
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      WEIGHT AT ARRIVAL
                    </td> */}
              <td className="py-2 px-4 text-left border border-gray-300">
                WEIGHBRIDGE IN DATE
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredDatas.map((value, index) => {
              const dri = driversLists?.find(
                (item) => item?.DRIVERCODE === value?.DRIVERCODE,
              );
              const prod = productsLists?.find(
                (item) => item?.ITEMCODE === value?.PRODUCTONARRIVAL,
              );

              return (
                <tr
                  key={index}
                  className="hover:bg-gray-100 cursor-pointer text-[13px]"
                  onClick={() => {
                    const dri = driversLists?.find(
                      (item) => item?.DRIVERCODE === value?.DRIVERCODE,
                    );
                    setDrivers(dri?.DRIVERNAME);
                    setDriverCodes(value?.DRIVERCODE);
                    setVehicleNos(value["TRUCKNO"]);
                    setInwardNos(value?.WBTICKETNO);
                    // setEmptyOrLoaded(value?.TRUCKEMPTYLOADEDONARRIVAL);
                    // setEmptyOrLoadedOut(
                    //   value?.TRUCKEMPTYLOADEDONARRIVAL === "EMPTY"
                    //     ? "LOADED"
                    //     : "EMPTY"
                    // );
                    // setWeight(value?.FIRSTWEIGHT);
                    setDates(value?.FIRSTWEIGHTDATETIME);
                    const prod = productsLists?.find(
                      (item) => item?.ITEMCODE === value?.PRODUCTONARRIVAL,
                    );
                    setWbNames(value?.WEIGHBRIDGENAME);
                    setWbNos(value?.WEIGHBRIDGENUMBER);
                    const clerk = clerkDatas?.find(
                      (item) =>
                        item?.["EMPLOYEE CODE"] === value?.WEIGHBRIDGECLERK,
                    );
                    setClerks(clerk?.["EMPLOYEE NAME"]);
                    setClerkCodes(value?.WEIGHBRIDGECLERK);
                    //
                    // setProduct(prod?.ITEMDESCRIPTION);
                    // setProductCode(value?.PRODUCTONARRIVAL);
                    setShowGateIns(true);
                  }}
                >
                  <td className="py-2 px-4 text-right border border-gray-300">
                    {index + 1}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value["WEIGHBRIDGENAME"] || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value["TRUCKNO"] || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {dri?.DRIVERNAME || "N/A"}
                  </td>
                  {/* <td className="py-2 px-4 text-left border border-gray-300">
                          {value["TRUCKEMPTYLOADEDONARRIVAL"] || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {prod?.ITEMDESCRIPTION || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.FIRSTWEIGHT || "N/A"}
                        </td> */}
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value["FIRSTWEIGHTDATETIME"]
                      ? moment(value["FIRSTWEIGHTDATETIME"]).format(
                          "DD/MM/YYYY",
                        )
                      : "N/A"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIns && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[300px] h-[80%] lg:w-[900px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="text-3xl font-bold flex lg:justify-center justify-start">
            WEIGHBRIDGE OUT
          </h1>
          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Inward No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={inwardNos}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-20">Date at arrival :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={dates?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-20">Time at arrival :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
          </div>
          {/* Row 2 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-6 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNos}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-8 mr-1">Driver :</p>
            <input
              className="w-52 h-8 border border-black lg:ml-14 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={drivers}
              readOnly
            ></input>
            {/* <p className="text-red-600 lg:ml-2">Weight at arrival:</p>
                  <input
                    className="w-24 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="number"
                    value={weight}
                    readOnly
                  ></input> */}
          </div>
          {/* Row 3 */}
          {/* <div className="lg:flex lg:flex-row mt-2"> */}
          {/* <p className="text-red-600 lg:ml-2 mr-1">Product at arrival:</p>
                  <input
                    className="w-56 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={product}
                    readOnly
                  ></input> */}

          {/* <p className="text-red-600 lg:ml-2 mr-1">
                    Empty/Loaded at arrival :
                  </p>
                  <input
                    className="w-56 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={emptyOrLoaded}
                    readOnly
                  ></input> */}
          {/* </div> */}
          {/* Row 4  */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Date Out :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={dateout?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-9">Time Out :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-10 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={timeOut}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Weighbridge :</p>

            {/* <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={wbNames}
                    readOnly
            ></input>
             */}

            {/* <p className="text-red-600 lg:ml-2">Weighbridge :</p> */}
            <Select
              className="lg:w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                wbNames
                  ? { value: wbNames, label: wbNames }
                  : { value: "", label: "Select Weighbridge" }
              }
              onChange={(e) => {
                setWbNames(e.value);
              }}
              options={[
                { value: "", label: "Select Weighbridge" },
                ...wbData?.map((item) => ({
                  value: item?.WBNAME,
                  label: item?.WBNAME,
                })),
              ]}
            ></Select>

            {/* <Select
                    className="lg:w-64 w-64 lg:ml-2"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    value={
                      wbName
                        ? { value: wbName, label: wbName }
                        : { value: "", label: "Select Weighbridge" }
                    }
                    onChange={(e) => {
                      setWbName(e.label);
                      setWbNo(e.value);
                    }}
                    options={[
                      { value: "", label: "Select Product" },
                      ...wbData?.map((item) => ({
                        value: item.WBNUMBER,
                        label: item.WBNAME,
                      })),
                    ]}
                  ></Select> */}

            {/* <p className="text-red-600 lg:ml-6">Weight at departure:</p>
                  <input
                    className="w-24 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="number"
                    value={weightOut}
                    onChange={(e) => setWeightOut(e.target.value)}
                  ></input> */}
          </div>
          {/* Row 5  */}
          {/* <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2 mr-1">Product at Departure :</p>
                  <Select
                    className="lg:w-56 w-64 lg:ml-2"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    value={
                      productOut
                        ? { value: productOut, label: productOut }
                        : { value: "", label: "Select Product" }
                    }
                    onChange={(e) => {
                      setProductOut(e.label);
                      setProductCodeOut(e.value);
                    }}
                    options={[
                      { value: "", label: "Select Product" },
                      ...productsList?.map((item) => ({
                        value: item.ITEMCODE,
                        label: item.ITEMDESCRIPTION,
                      })),
                    ]}
                  ></Select>
      
                  <p className="text-red-600 lg:ml-2 mr-1">
                    Empty/Loaded at Departure:
                  </p>
                  <input
                    className="w-56 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={emptyOrLoadedOut}
                    readOnly
                  ></input>
                </div> */}

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Weighbridge Clerk :</p>
            <input
              className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={clerks}
              readOnly
            ></input>
            {/* <Select
                    className="lg:w-64 w-64 lg:ml-2"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    value={
                      clerk
                        ? { value: clerk, label: clerk }
                        : { value: "", label: "Select Weighbridge Clerk" }
                    }
                    onChange={(e) => {
                      setClerk(e.label);
                      setClerkCode(e.value);
                    }}
                    options={[
                      { value: "", label: "Select Weighbridge Clerk" },
                      ...clerkData?.map((item) => ({
                        value: item["EMPLOYEE CODE"],
                        label: item["EMPLOYEE NAME"],
                      })),
                    ]}
                  ></Select> */}

            <p className="text-red-600 lg:ml-12">Proceed To :</p>
            <Select
              className="lg:w-80 lg:ml-2"
              menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
              }}
              value={
                proceedToState
                  ? { value: proceedToState, label: proceedToState }
                  : { value: "", label: "Select State" }
              }
              onChange={(e) => {
                setProceedToState(e.label);
                setProceedToStateValue(e.value);
              }}
              options={[
                { value: "", label: "Select State" },
                { value: "SENT TO WORKSHOP", label: "PROCEED TO WORKSHOP" },
                { value: "SENT TO LOAD", label: "PROCEED TO LOAD" },
                {
                  value: "DISPATCHED",
                  label: "PROCEED TO GATE OUT",
                },
              ]}
            ></Select>
          </div>
          <div className="flex justify-center mt-5">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                await SaveOut();
              }}
            >
              WEIGH OUT
            </button>
          </div>
          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIns(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default WeighbridgeIn;
